export default __webpack_public_path__ + "static/footer-badge-2-97223d279be634fbe89236fd8b773a01.svg";